<template>
    <div>
        <b-breadcrumb class="text-capitalize">
            <b-breadcrumb-item :to="{ name: 'OrganizationList' }"><font-awesome-icon icon="caret-right" class="mr-1" />Organizations</b-breadcrumb-item>
            <b-breadcrumb-item :to="{ name: 'OrganizationList' }" active> {{organizationName.truncate(32)}}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="container-fluid px-4">

            <b-card class="mb-3" >
                <b-card-title>
                    <span>{{ organizationName }}</span>
                    <b-button size="sm" class="mx-2" style="border-width: 0px" variant="outline-secondary" v-on:click.stop="onEditOrganization()">
                        <font-awesome-icon icon="edit" />
                    </b-button>
                </b-card-title>
                <b-card-sub-title class="mb-2">
                    <span>Manage user roles. Invite new users to your organization.</span>
                </b-card-sub-title>
                <b-button size="sm" variant="primary" v-on:click.stop="onAdd()">Invite New User</b-button>
            </b-card>

          <b-card class="my-1">
            <div class="container-fluid p-0 my-0">
                <div class="row no-gutters justify-content-start">
                    <div class="col">
                        <b-input-group size="sm" class="my-1">
                            <b-input-group-prepend>
                                <b-button variant="outline-secondary" v-on:click.stop="refreshTable()">
                                    <font-awesome-icon icon="sync-alt" class="mx-1" />
                                    Refresh
                                </b-button>
                            </b-input-group-prepend>
                            <b-input-group-prepend>
                                <b-input-group-text >
                                    <font-awesome-icon icon="search" class="mx-1" />
                                </b-input-group-text>
                            </b-input-group-prepend>
                            <b-form-input v-model="searchTerm" placeholder="Search"></b-form-input>
                        </b-input-group>
                    </div>
                </div>
            </div>
          </b-card>

            <b-overlay :show="isLoading" rounded="sm">

                <ErrorView :visible="isLoadingError" :errorValue="loadingErrorValue"/>

                <vue-good-table v-if="isLoadingError == false" styleClass="vgt-table bordered striped condensed"
                                :columns="columns"
                                :rows="items.data"
                                :sort-options="{
                                  enabled: true,
                                  initialSortBy: {field: 'name', type: 'asc'}
                                }"
                                :search-options="{
                                    enabled: true,
                                    externalQuery: searchTerm
                                }"

                                @on-row-click="onRowClick">
                    <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'action'">
                            <div class="float-right">

                                <!-- TODO change roles
                                <b-button size="sm" class="mx-2" variant="outline-primary" v-on:click.stop="onEdit(props.row)">
                                    <font-awesome-icon icon="edit" />
                                </b-button>
                                -->

                               <b-button size="sm" class="mx-2" variant="outline-danger" v-on:click.stop="onDelete(props.row)">
                                   <font-awesome-icon icon="trash" />
                               </b-button>

                           </div>
                       </span>
                       <span v-else-if="props.column.field == 'name'">
                           <b-avatar class="mx-2 my-0" rounded="sm" variant="light">
                              <font-awesome-icon icon="user" />
                           </b-avatar>
                           <div style="display: inline-block; vertical-align: middle;">
                             <span>{{getUserName(props.row.userAccount).truncate(32)}}</span>
                             <br/>
                             <span style="font-size: x-small; color: #cccccc">{{getUserEmail(props.row.userAccount)}}</span>
                           </div>
                       </span>
                       <span v-else-if="props.column.field == 'roles'">
                         <b-badge v-if="props.row.roles === 'athlete'" pill variant="secondary">{{props.row.roles}}</b-badge>
                         <b-badge v-else pill variant="primary">{{props.row.roles}}</b-badge>
                       </span>
                       <span v-else>
                         {{props.formattedRow[props.column.field]}}
                       </span>
                   </template>
               </vue-good-table>
           </b-overlay>

       </div>

       <OrganizationModal/>
       <OrganizationInviteUserModal/>
       <OrganizationRemoveUserModal/>

   </div>
</template>

<script>
   import { VueGoodTable } from 'vue-good-table';
   import { mapGetters, mapActions } from 'vuex'
   import OrganizationModal from './OrganizationModal'
   import OrganizationInviteUserModal from './OrganizationInviteUserModel'
   import OrganizationRemoveUserModal from './OrganizationRemoveUserModel'
   import ErrorView from '../ErrorView'

   export default {
       name: "OrganizationDetailsPage",
       components: {
           VueGoodTable,
           OrganizationModal,
           OrganizationInviteUserModal,
           OrganizationRemoveUserModal,
           ErrorView
       },
       data () {
           return {
               organizationId: this.$route.params.orgId,

               searchTerm: '',
               columns: [
                   {
                       label: 'User',
                       field: 'name',
                       sortable: true,
                   },
                   {
                       label: 'Roles',
                       field: 'roles',
                       sortable: false,
                       tdClass: 'text-capitalize'
                   },
                   {
                       label: '',
                       field: 'action',
                       sortable: false,
                   },
               ],

           }
       },
       created () {
           if(!this.organizationId) {
               this.$router.push({name: 'OrganizationList'});
           } else {
               this.refreshOrganization();
               this.refreshTable();
           }
       },
       watch: {
           itemsDirty(newValue) {
               if(newValue) {
                   this.refreshTable()
               }
           }
       },
       computed: {
           ...mapGetters({
               organization: 'organization/current',
               organizationName: 'organization/currentName',
               organizationLoading: 'organization/currentLoading',
               organizationLoadingErrorValue: 'organization/currentLoadingErrorValue',

               items: 'organizationUserAccount/items',
               itemsLoading: 'organizationUserAccount/itemsLoading',
               itemsLoadingError: 'organizationUserAccount/itemsLoadingError',
               itemsLoadingErrorValue: 'organizationUserAccount/itemsLoadingErrorValue',
               itemsDirty: 'organizationUserAccount/itemsDirty'
           }),

           isLoading: function() {
               return this.itemsLoading || this.organizationLoading;
           },
           isLoadingError: function() {
               return this.itemsLoadingError || (!this.isLoading && !this.items);
           },
           loadingErrorValue: function() {
               if(this.itemsLoadingErrorValue)
                   return this.itemsLoadingErrorValue;

               return this.organizationLoadingErrorValue;
           },

       },
       methods: {
           ...mapActions({
               selectOrganization: 'organization/select',
               selectOrganizationUserAccount: 'organizationUserAccount/select',
               listOrganizationUserAccounts: 'organizationUserAccount/list',
           }),
           refreshOrganization() {
               this.selectOrganization(this.organizationId)
           },

           refreshTable() {
               this.listOrganizationUserAccounts();
           },

           onEditOrganization() {
               this.$bvModal.show('edit-organization-modal')
           },

           onRowClick() {
               // params.row - row object
               //this.$router.push({name: 'SessionList', params: {athleteId: params.row.athleteId}})
           },
           onAdd() {
               this.$bvModal.show('invite-user-modal')
           },
           onEdit() {
               alert("edit");
           },
           onDelete(item) {
               this.selectOrganizationUserAccount(item.userAccountId);
               this.$bvModal.show('remove-user-modal')
           },


           getUserName:(model) => {
               let name = '-';
               if(model){
                   let first = model.firstName;
                   let last = model.lastName;
                   let email = model.emailAddress;
                   let id = model.userAccountId;

                   name = '';
                   if(first !== undefined && first != '') {
                       name = first;
                   }
                   if(last !== undefined && last != '') {
                       name = name + ' ' + last;
                   }
                   if(name == '' && email !== undefined && email != '') {
                       name = email;
                   }
                   if(name == '' && id !== undefined && id != '') {
                       name = '#' + id;
                   }
               }

               return name;
           },

          getUserEmail:(model) => {

            if(model && model.emailAddress) {
              return model.emailAddress;
            }
            return '';
          },
       }
   }
</script>

<style scoped>

</style>